import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-tour-button",
  templateUrl: "./tour-button.component.html",
  styleUrls: ["./tour-button.component.scss"],
})

/**
 * Tour Button Component
 * Floating button component for starting tours/guides
 */
export class TourButtonComponent {
  @Output() tourClick = new EventEmitter<void>();

  onTourClick(): void {
    this.tourClick.emit();
  }
}

